import React, { memo, useState, useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { makeSelectFilterMenuStatus, makeSelectNiveauFilterDataArray } from '../selectors';
import { toggleNiveauFilterMenu } from './actions';
import ParentElement from '../../../components/FilterElement/ParentElement';
import { useInjectReducer } from '../../../utils/injectReducer';
import reducer from './reducer';
import { NIVEAU_FILTER_LABEL } from '../../../utils/site';

const key = 'niveau';

export const FilterCollapse = ({
  niveauFilterDataArray,
  onToggleNiveauFilterMenu,
  niveauFilterMenuStatus,
}) => {
  useInjectReducer({ key, reducer });
  const [bubbleString, setBubbleString] = useState('');

  useEffect(() => {
    let newBubbleString = '';
    if (niveauFilterDataArray.length > 0) {
      newBubbleString = niveauFilterDataArray[0];
    }
    if (bubbleString !== newBubbleString) {
      setBubbleString(newBubbleString);
    }
  }, [niveauFilterDataArray]);

  /**
   * Main return function.
   */
  return (
    <div onClick={() => onToggleNiveauFilterMenu(niveauFilterMenuStatus)}>
      <ParentElement title={NIVEAU_FILTER_LABEL} bubble={bubbleString} status={niveauFilterMenuStatus} />
    </div>
  );
};

FilterCollapse.propTypes = {
  niveauFilterDataArray: PropTypes.array,
  onToggleNiveauFilterMenu: PropTypes.func,
  niveauFilterMenuStatus: PropTypes.bool,
};

FilterCollapse.defaultProps = {
  niveauFilterDataArray: [],
  onToggleNiveauFilterMenu: () => {},
  niveauFilterMenuStatus: true,
};

const mapStateToProps = createStructuredSelector({
  niveauFilterDataArray: makeSelectNiveauFilterDataArray(),
  niveauFilterMenuStatus: makeSelectFilterMenuStatus(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onToggleNiveauFilterMenu: (value) => dispatch(toggleNiveauFilterMenu(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(FilterCollapse);
